export default "__VITE_ASSET__CGRV71uy__"